import { useMemo, useState } from 'react';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardIPConsultsCOMTable from './DashboardIPConsultsCOMTable/DashboardIPConsultsCOMTable';
import { DashboardIPConsultsCOMFilters } from './DashboardIPConsultsCOM.types';
import { DashboardIPConsultsCOMContext } from './DashboardIPConsultsCOM.context';
import DashboardIPConsultsCOMFiltersModal from './DashboardIPConsultsCOMFiltersModal/DashboardIPConsultsCOMFiltersModal';

export default () => {
  const [isFiltersModalOpen, setFiltersModalOpen] = useState(false);

  const [filters, setFilters] = useState<DashboardIPConsultsCOMFilters>({
    domains: [],
    fieldsOfActivity: [],
  });

  const contextValue = useMemo(
    () => ({
      isFiltersModalOpen,
      setFiltersModalOpen,
      filters,
      setFilters,
    }),
    [isFiltersModalOpen, setFiltersModalOpen, filters, setFilters]
  );

  return (
    <DashboardIPConsultsCOMContext.Provider value={contextValue}>
      <DashboardLayout>
        <DashboardIPConsultsCOMTable />
        <DashboardIPConsultsCOMFiltersModal
          isOpen={isFiltersModalOpen}
          setOpen={setFiltersModalOpen}
        />
      </DashboardLayout>
    </DashboardIPConsultsCOMContext.Provider>
  );
};
